export default {
  StaffAccessAll: 'StaffAccessAll',
  StaffBtnAgreementsAdd: 'StaffBtnAgreementsAdd',
  StaffBtnAgreementsAddTerminationDate: 'StaffBtnAgreementsAddTerminationDate',
  StaffBtnAgreementsDeductions: 'StaffBtnAgreementsDeductions',
  StaffBtnAgreementsDeductionsAdd: 'StaffBtnAgreementsDeductionsAdd',
  StaffBtnAgreementsDelete: 'StaffBtnAgreementsDelete',
  StaffBtnAgreementsEdit: 'StaffBtnAgreementsEdit',
  StaffBtnAgreementsGenerateBill: 'StaffBtnAgreementsGenerateBill',
  StaffBtnAgreementsGenerateIndividualPayment: 'StaffBtnAgreementsGenerateIndividualPayment',
  StaffBtnAgreementsPreview: 'StaffBtnAgreementsPreview',
  StaffBtnAgreementsPrintAgreement: 'StaffBtnAgreementsPrintAgreement',
  StaffBtnBillsDelete: 'StaffBtnBillsDelete',
  StaffBtnBillsEdit: 'StaffBtnBillsEdit',
  StaffBtnBillsGenerateBills: 'StaffBtnBillsGenerateBills',
  StaffBtnBillsPreview: 'StaffBtnBillsPreview',
  StaffBtnBillsPrintAllBills: 'StaffBtnBillsPrintAllBills',
  StaffBtnBillsPrintBill: 'StaffBtnBillsPrintBill',
  StaffBtnDeclarationsPitAdd: 'StaffBtnDeclarationsPitAdd',
  StaffBtnDeclarationsPitDelete: 'StaffBtnDeclarationsPitDelete',
  StaffBtnDeclarationsPitPrint: 'StaffBtnDeclarationsPitPrint',
  StaffBtnDeclarationsPitPrintUPO: 'StaffBtnDeclarationsPitPrintUPO',
  StaffBtnDeclarationsPitRefresh: 'StaffBtnDeclarationsPitRefresh',
  StaffBtnDeductionsDelete: 'StaffBtnDeductionsDelete',
  StaffBtnDeductionsEdit: 'StaffBtnDeductionsEdit',
  StaffBtnDeductionsPreview: 'StaffBtnDeductionsPreview',
  StaffBtnEmployeeActivateAccount: 'StaffBtnEmployeeActivateAccount',
  StaffBtnEmployeeAdd: 'StaffBtnEmployeeAdd',
  StaffBtnEmployeeDeactivateAccount: 'StaffBtnEmployeeDeactivateAccount',
  StaffBtnEmployeeDelete: 'StaffBtnEmployeeDelete',
  StaffBtnEmployeeEdit: 'StaffBtnEmployeeEdit',
  StaffBtnEmployeePreview: 'StaffBtnEmployeePreview',
  StaffBtnPaymentDelete: 'StaffBtnPaymentDelete',
  StaffBtnPaymentEdit: 'StaffBtnPaymentEdit',
  StaffBtnPaymentPreview: 'StaffBtnPaymentPreview',
  StaffBtnPaymentPrintPayment: 'StaffBtnPaymentPrintPayment',
  StaffBtnPaymentRecalculate: 'StaffBtnPaymentRecalculate',
  StaffBtnPayrollDelete: 'StaffBtnPayrollDelete',
  StaffBtnPayrollEmployeesList: 'StaffBtnPayrollEmployeesList',
  StaffBtnPayrollGeneratePayroll: 'StaffBtnPayrollGeneratePayroll',
  StaffBtnPayrollPrintPayroll: 'StaffBtnPayrollPrintPayroll',
  StaffColumnEmployeeActivated: 'StaffColumnEmployeeActivated',
  StaffFormAgreementsEditable: 'StaffFormAgreementsEditable',
  StaffFormBillsEditable: 'StaffFormBillsEditable',
  StaffFormDeductionsEditable: 'StaffFormDeductionsEditable',
  StaffFormEmployeeEditable: 'StaffFormEmployeeEditable',
  StaffFormPaymentEditable: 'StaffFormPaymentEditable',
  StaffPageAgreementsAdd: 'StaffPageAgreementsAdd',
  StaffPageAgreementsDeductionsAdd: 'StaffPageAgreementsDeductionsAdd',
  StaffPageAgreementsDeductionsEdit: 'StaffPageAgreementsDeductionsEdit',
  StaffPageAgreementsDeductionsList: 'StaffPageAgreementsDeductionsList',
  StaffPageAgreementsEdit: 'StaffPageAgreementsEdit',
  StaffPageAgreementsList: 'StaffPageAgreementsList',
  StaffPageBillsEdit: 'StaffPageBillsEdit',
  StaffPageBillsGenerate: 'StaffPageBillsGenerate',
  StaffPageBillsList: 'StaffPageBillsList',
  StaffPageDeclarationsPitList: 'StaffPageDeclarationsPitList',
  StaffPageEmployeesAdd: 'StaffPageEmployeesAdd',
  StaffPageEmployeesEdit: 'StaffPageEmployeesEdit',
  StaffPageEmployeesList: 'StaffPageEmployeesList',
  StaffPageLeavesAdd: 'StaffPageLeavesAdd',
  StaffPageLeavesEdit: 'StaffPageLeavesEdit',
  StaffPageLeavesList: 'StaffPageLeavesList',
  StaffPageAccidentInsurancesEdit: 'StaffPageAccidentInsurancesEdit',
  StaffPageAccidentInsurancesList: 'StaffPageAccidentInsurancesList',
  StaffPagePayrollEmployeesEdit: 'StaffPagePayrollWorkerEdit',
  StaffPagePayrollEmployeesList: 'StaffPagePayrollWorkerList',
  StaffPagePayrollEmployeesRecalculate: 'StaffPagePayrollEmployeesRecalculate',
  StaffPagePayrollList: 'StaffPagePayrollList',
};
